import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

// @ngrx
import { Store } from '@ngrx/store';

// rxjs


import * as SpinnerReducer from '@store/spinner/reducers';

@Injectable()
export class AuthService {
  constructor(
    private httpClient: HttpClient,
    private store: Store<SpinnerReducer.SpinnerState>
  ) { }

  login({loginName, password, rememberMe}) {
    return  this.httpClient.post('auth', {loginName, password, rememberMe});
  }

  logout(token?: string) {
    const options: {headers?: HttpHeaders} = {};
    if (token) {
      options.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }

    return this.httpClient.post('auth/logout', {}, options);
  }

  loginBySocialAcc(provider: string, token: string) {
    return this.httpClient.post(`social/${provider}`, {token: token});
  }

  register(body) {
    return  this.httpClient.post('auth/register', body);
  }

  sendEmailForResettingPassword(loginName: string, redirect: string) {
    return  this.httpClient.post('password/change', {loginName, redirectPath: redirect});
  }

  sendEmail(email: string, redirect: string) {
    return  this.httpClient.post('verify/email', {email: email, redirectPath: redirect});
  }

  welcome(schoolId) {
    return  this.httpClient.get('school/' + schoolId + '/welcome/on_boarding_welcome');
  }

  getFamily(parentId) {
    return  this.httpClient.get('account/' + parentId);
  }

  sendSms(email: string) {
    return  this.httpClient.post('verify/sms', {email: email});
  }

  resetPassword({password, password_confirmation}) {
    return  this.httpClient.post('password/reset', {password, password_confirmation});
  }

  checkResetPasswordToken(token: string) {
    return  this.httpClient.post('auth/checkToken', {token: token});
  }

  validate(number: string, countryCode: string) {
    return this.httpClient.get(`auth/validatePhoneNumber/${number}/${countryCode}`);
  }
}
